(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    if (!motion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('rangona-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      root.querySelectorAll('[data-rangona-reveal]').forEach(el => {
        if (!el.classList.contains('rangona-visible')) {
          el.classList.add('rangona-reveal');
          observer.observe(el);
        }
      });
    }
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rangona-scroll]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    rail?.scrollBy({ left: Number(button.dataset.rangonaScroll) * rail.clientWidth * 0.8, behavior: motion.matches ? 'instant' : 'smooth' });
  });
  const header = document.querySelector('header-component');
  const updateHeader = () => header?.classList.toggle('rangona-scrolled', scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  const bubble = document.querySelector('cart-icon .cart-bubble');
  if (bubble) {
    let count = bubble.textContent.trim();
    new MutationObserver(() => {
      const next = bubble.textContent.trim();
      if (next === count || motion.matches) return;
      count = next;
      bubble.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 350, easing: 'ease-out' });
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
})();

(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.header-actions__action,.header__icon--menu,.rangona-hero__cta,.rangona-promo__content a,.rangona-motion__button,.rangona-shopping-story__button,.rangona-film__link,.rangona-featured__view,.rangona-benefit__icon,.add-to-cart-button,.product-form__submit,.rangona-card__button,.rangona-carousel-nav button,.quick-add__button,footer .social-icons__icon-wrapper a,footer .email-signup__button,.button:not(.button-secondary):not(.button-unstyled)';
  const enhance = root => {
    root.querySelectorAll(selector).forEach(control => {
      if (control.querySelector(':scope > .rangona-glass-surface')) return;
      control.classList.add('rangona-glass-control');
      const surface = document.createElement('span');
      surface.className = 'rangona-glass-surface';
      surface.setAttribute('aria-hidden', 'true');
      control.append(surface);
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  let frame;
  new MutationObserver(records => {
    if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && !node.classList?.contains('rangona-water-ripple') && !node.classList?.contains('rangona-glass-surface')))) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => enhance(document));
  }).observe(document.body, { childList: true, subtree: true });
  const ripple = (control, x, y) => {
    if (reduceMotion.matches || control.matches(':disabled,[aria-disabled="true"]')) return;
    const surface = control.querySelector(':scope > .rangona-glass-surface');
    if (!surface) return;
    const drop = document.createElement('span');
    drop.className = 'rangona-water-ripple';
    drop.style.left = x + 'px';
    drop.style.top = y + 'px';
    surface.append(drop);
    drop.addEventListener('animationend', () => drop.remove(), { once: true });
  };
  document.addEventListener('pointerdown', event => {
    const control = event.target.closest(selector);
    if (!control) return;
    const bounds = control.getBoundingClientRect();
    ripple(control, event.clientX - bounds.left, event.clientY - bounds.top);
  }, { passive: true });
  document.addEventListener('focusin', event => {
    const control = event.target.closest(selector);
    if (!control?.matches(':focus-visible')) return;
    ripple(control, control.clientWidth / 2, control.clientHeight / 2);
  });
})();
